import { API } from "aws-amplify";

export const getInitial = token => {
  return API.get("v1", "/initial", {
    headers: {
      Authorization: token
    }
  });
};

export const getPackages = token => {
  return API.get("v1", "/get_packages", {
    headers: {}
  });
};

export const createOrder = (token, data = {}) => {
  return API.post("v1", "/order", {
    body: data,
    headers: {
      Authorization: token,
    }
  });
};

export const issueCovid = (token, order_id, data = {}) => {
  return API.post("v1", "/issue_covid/" + order_id, {
    body: data,
    headers: {
      Authorization: token
    }
  });
};

export const getOtp = (token) => {
  return API.get("v1", "/otp", {
    headers: {
      Authorization: token
    }
  });
};
